const ar = {
  home: 'الرئيسية',
  dashboard: 'لوحة المعلومات',
  noServicesFoundPleaseTryAgain: 'لا توجد خدمات',
  serviceUsage: 'استخدام الخدمة',
  more: 'المزيد',
  verificationServices: {
    title: 'خدمات التحقق',
    description: 'تمكنك هذه الخدمة من التحقق من الوثائق الصادرة من وزارة العدل إلكترونياً',
    userNeed: 'أريد التحقق من',
    browseVerificationServices: 'تصفح خدمات التحقق',
  },

  electronicServices: {
    title: 'الخدمات الإلكترونية',
    mostUsed: 'الأكثر إستخداما',
    judiciary: 'القضاء',
    realEstate: 'العقاري',
    documentation: 'التوثيق',
    lawyers: 'المحامين',
  },
  search: 'بحث',
  back: 'رجوع',
  endDate: 'تاريخ الانتهاء',
  currentServices: 'خدماتي الحالية',
  searchResult: 'نتائج البحث',
  realEstates: 'صكوك العقارات الالكترونية',
  marrigeContracts: 'طلبات الزواج الالكترونية',
  judicialLicences: 'التراخيص العدلية',
  searchLengthError: 'رساله البحث اقل من أربعة مقاطع',
  all: 'الكل',
  faq: 'الأسئلة الشائعة',
  loading: 'جاري تحميل البيانات',
  useTheService: 'استخدام الخدمة',
  startTheService: 'بدء الخدمة',
  portalServices: {
    title: 'الخدمات الإلكترونية',
    searchInServices: 'ابحث في الخدمات الإلكترونية',
    allServices: 'جميع الخدمات',
    readMore: 'شرح الخدمة',
    use: 'ابدأ الخدمة',
    new: 'جديد',
    newlyAdded: 'جديد',
    modified: 'محدث',
    favorites: 'المفضلة',
    mostUsed: 'الأكثر استخداما',
    useTheService: 'استخدام الخدمة',
    moveToService: 'الانتقال الى خدمة',
  },
  serviceDetails: {
    describeService: 'وصف الخدمة',
    steps: 'خطوات التقديم على الخدمة',
    serviceRequirements: 'متطلبات الخدمة',
    channels: 'قنوات تقديم الخدمة',
    serviceInformation: 'يجب أن تعرف',
  },
  router: {
    licenseGuide: 'دليل المرخصين',
    notifications: 'الاشعارات',
    verificationServices: 'خدمات التحقق',
    privacyPolicy: 'سياسة الخصوصية',
    termsAndConditions: 'الشروط والأحكام',
    home: 'الرئيسية',
    mostUsedServices: 'الخدمات الإلكترونية',
    theSearch: 'البحث',
  },
  telemetry: {
    quickAccessLink: 'النقر على رابط التنقل السريع لخدمة',
    moreDetails: 'النقر على رابط المزيد لبطاقة',
    serviceLink: 'النقر على رابط الخدمة:',
    forCard: 'لبطاقة',
    dashboarLink: 'الوصول الى لوحة المعلومات',
  },
  serverErrors: {
    NOT_FOUND: 'لا يمكننا خدمتك في الوقت الحالي. الرجاء المحاولة لاحقاً',
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
  },
  fetchingData: 'جاري تحميل البيانات ...',
  viewSearchResults: 'عرض نتيجة البحث ({count} نتيجة)',
  browseService: 'تصفح الخدمة ',
  noSearchResultsFound: 'لا يوجد نتائج تطابق البيانات المدخلة',
  pleaseRevalidateSearchCriteriaAndCheckAgain: 'الرجاء التأكد من البيانات، والمحاولة مجدداً.',
  mostProminentServices: 'أبرز الخدمات',
  showMore: 'عرض المزيد',
  showDetails: 'عرض التفاصيل',
  latestNotifications: 'آخر الإشعارات',
  judicialProfile: 'الملف العدلي',
  judicialProfileDescription: 'كل مايخص معلوماتك العدلية القضاء والوكالات وغيرها من الخدمات. ',
  judicialProfileFirstDescription: 'كل مايخص معلوماتك العدلية ',
  judicialProfileSecondDescription: ' من القضاء والوكالات وغيرها من الخدمات.',
  viewAll: 'مشاهدة الكل',
  viewLess: 'مشاهدة أقل',
  serviceExecutionTime: 'مدة تنفيذ الخدمة',
  serviceExecutionTimeDescription: 'من {from} إلى {to}',
  serviceProviderChannels: 'قنوات تقديم الخدمة',
  beneficiaries: 'الفئة المستهدفة',
  serviceFees: 'رسوم الخدمة ',
  commonFaqs: 'الأسئلة الشائعة',
  checkFaqs: 'الاطلاع على الأسئلة الشائعة',
  clickHere: 'اضغط هنا',
  allServices: 'جميع الخدمات',
  downloadApp: 'تحميل التطبيق',
  usageGuide: 'دليل الأستخدام',
  downloadUsageGuide: 'تنزيل دليل الإستخدام',
  theDescription: 'الوصف',
  theRequirments: 'المتطلبات',
  theSteps: 'الخطوات',
  serviceDescription: 'وصف الخدمة',
  serviceRequirments: 'متطلبات الخدمة',
  stepsToApplyForTheService: 'خطوات التقديم على الخدمة',
  submitNewRequest: 'تقديم طلب جديد',
  followUpOnPreviousRequest: 'متابعة طلب سابق',
  authenticationOfCompletedRequest: 'مصادقة طلب مكتمل',
  youShouldKnow: 'يجب أن تعرف',
  share: 'مشاركة',
  serviceLinkCopiedSuccessfully: 'تم نسخ رابط الخدمة بنجاح',
  attorneyUpdatedSuccessfully: 'تم تحديث بيانات الوكالة بنجاح',
  instant: 'فورية',
  sections: 'الأقسام',
  searchResults: 'نتائج البحث ({searchText})',
  sessionFollowUp: 'متابعة الجلسة',
  accountUdpdatedSuccesfully: 'تم تحديث بيانات الحساب بنجاح',
  accountsManagements: 'إدارة الحساب',
  email: 'البريد الإلكتروني',
  withMaxLengthChars: 'بحد أقصى {length} حرف',

  contactWithUs: {
    title: 'تواصل معنا',
    slogan: 'نحن هنا لخدمتكم ويمكنكم التواصل معنا في أي وقت',
    contactInsideKSA: 'تواصل معنا من داخل المملكة',
    fromSunToThurs: 'من الأحد إلى الخميس',
    fromInsideKSA: 'من داخل المملكة العربية السعودية',
    contactUs: 'تواصل معنا',
    contactOutsideKSA: 'اتصل بنا من خارج المملكة',
    contactTime: 'من 8 صباحاً إلى 2:15 مساءً (الأحد - الخميس)',
    fromOutsideKSA: 'من خارج المملكة العربية السعودية',
    messageUs: 'راسلنا',
    allWeekDays: 'طوال أيام الاسبوع',
    allTheTime: 'جميع الأوقات',
    instantChat: 'المحادثة الفورية',
    chatWithUs: 'تحدث معنا',
    pleaseToServeYou: 'نسعد بخدمتكم بجميع مراكز ناجز',
    najizCenterRiyadhBranch: 'مركز ناجز فرع الرياض',
    najizCenterRiyadhBranchLocation: 'طريق أنس ابن مالك، الملقا، الرياض 13524',
    location: 'الموقع',
    workingDays: 'أيام العمل',
    workingTime: 'أوقات العمل',
    from: 'من',
    until: 'حتى',
    atMorning: 'صباحاً',
    atNight: 'مساًء',
    najizCenterJeddahBranch: 'مركز ناجز فرع جدة',
    najizCenterJeddahBranchLocation: 'ساري ، حي الخالدية ،جدة 23423',
    najizCenterDammamBranch: 'مركز ناجز فرع الدمام',
    najizCenterDammamBranchLocation: 'طريق الظهران الجبيل السريع، الروضة،,الدمام',
    socialMediaAccounts: 'حسابات التواصل الاجتماعي',
    x: 'إكس',
    instagram: 'إنستقرام',
    snapchat: 'سناب شات',
    youtube: 'يوتيوب',
    facebook: 'فيسبوك',
    linkedin: 'لينكد إن',
    contactChannels: 'قنوات استقبال الاستفسارات والشكاوى',
    name: 'الاسم',
    enterTheName: 'أدخل الاسم',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'Example@email.com',
    phone: 'رقم الجوال',
    phonePlaceholder: '05xxxxx',
    messageTitle: 'عنوان الرسالة',
    messageTitlePlaceholder: 'أدخل عنوان الرسالة',
    messageCategory: 'فئة الرسالة',
    messageText: 'نص الرسالة',
    theMessage: 'الرسالة',
    send: 'إرسال',
    serviceAvailability: 'توفر الخدمة',
    contactNumber: 'رقم التواصل',
    responseTime: 'زمن الاستجابة',
    instant: 'فوري',
    serviceType: 'نوع الخدمة',
    liveChat: 'محادثة مباشرة',
    inquiriesAndComplaints: 'الاستفسارات والشكاوى',
    supportWithSignLanguage: 'الدعم بلغة الإشارة',
    tenDaysWork: '10 أيام عمل',
    twoWorkDays: 'يومين عمل',
    judicialContact: 'التواصل العدلي',
    signSupport: 'دعم الإشارة',
    question: 'سؤال',
    suggestion: 'اقتراح',
    help: 'مساعدة',
    messageSentSuccessfully: 'تم إرسال الرسالة بنجاح',
    contactSample: 'نموذج الاتصال',
  },

  validations: {
    fieldIsRequired: 'هذا الحقل مطلوب',
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
    maxInputsLength: 'أقصى عدد للمدخلات هو {length}',
    numbersExactLength: ' عدد الأرقام يجب أن يكون {length}',
    startsWith: ' يجب أن يبدأ ب {listText}',
    phoneNumber: 'يجب أن يبدأ رقم الجوال ب {key} وأن يكون {length} أرقام',
    emailAddress: 'الرجاء إدخال بريد إلكتروني صحيح',
    onlyArabicAndNumbers: 'الرجاء إدخال أحرف عربية وأرقام فقط.',
    onlyArabicOrNumbers: 'الرجاء إدخال أحرف عربية أو أرقام فقط.',
    specialCharacters: 'الرجاء عدم إدخال رموز خاصة.',
    twitterId: 'يجب أن يكون المعرف كالآتي http(s)://twitter.com/xyz123',
    facebookId: 'يجب أن يكون المعرف كالآتي http(s)://facebook.com/xyz123',
    minWordsLength: 'أقل عدد للكلمات يجب أن يكون {length}',
    theNameMustBeBinary: 'يجب أن يكون الإسم ثنائياً',
    onlyArabic: 'يجب إدخال أحرف عربية فقط',
    duplicatePhoneNumberInContactInfo: 'يجب أن لايتطابق رقم الشخص الأول مع الشخص الثاني',
    duplicatePhoneNumberInApplicantInfo: 'يجب أن لايتطابق رقم الجوال مع رقم الجوال في البيانات الشخصية',
    alphaNumeric: 'الرجاء إدخال أحرف إنجليزية وأرقام  فقط.',
    alphaNumericAndSpecialChars: 'الرجاء إدخال أحرف إنجليزية وأرقام ورموز خاصة مثل {chars}',
  },

  faqs: {
    title: 'الأسئلة المتكررة',
    searchPlaceholder: 'ابحث هنا، مثلاً: كيفية إنشاء صحيفة دعوى',
    howCanWeHelpYou: 'كيف يمكننا مساعدتك؟',
    browseAllQuestions: 'تصفح جميع الأسئلة',
    noQuestionsAvailable: 'لا توجد أسئلة.',
    shareQuestion: 'مشاركة السؤال',
    questionLinkCopiedSuccessfully: 'تم نسخ رابط السؤال بنجاح',
    questionDetails: 'تفاصيل السؤال',
    questionDetailsNotAvailable: 'بيانات السؤال غير متاحة',
  },
  contactUs: {
    title: 'تواصل معنا',
    forMoreContacts: 'لمزيد من قنوات التواصل',
  },
};

export default ar;
